import React from 'react';


// import YourVote from '../img/yourvote2020.png';
import YourVoteLogo from '../img/your-vote-2020-no-bg.png';

class Footer extends React.Component {
    state = {
        year: new Date().getFullYear()
    }
    
    render(){
       return (
         <React.Fragment>
          <div className="stuffHeader-footercontainer">
          <div className="stuffHeader-container--rainbow"></div>
          <div className="stuffHeader-footercontainer--readmorecontainer">
              <span className="stuffHeader-footercontainer--readmorecontainer---titlebox">
                  <div className="stuffHeader-footercontainer--fulllogo">
                    <img className="stuffHeader-footercontainer--fulllogo--logo"  src={YourVoteLogo} alt="vote2020logo"/>
                  </div>
                  {/* <img className="stuffHeader-footercontainer--readmorecontainer---titlebox--logo" alt="yourvote2020-logo" src={YourVote} /> */}
                  <span className="stuffHeader-footercontainer--readmorecontainer---titlebox--title">More coverage on Stuff</span>
              </span>
              <div className="stuffHeader-footercontainer--readmorecontainer---box">
                  <a href="https://my.stuff.co.nz/register/newsletter?type=politicallyCorrect&cid=politicallyCorrect:editorial:pointer" rel="noopener noreferrer" target="_blank" className="stuffHeader-footercontainer--readmorecontainer---box--each">
                      <span>Politically Correct newsletter</span>
                  </a>
                  <a href="https://www.stuff.co.nz/national/politics/tick-tick-podcast" rel="noopener noreferrer" target="_blank" className="stuffHeader-footercontainer--readmorecontainer---box--each">
                      <span>Tick. Tick. Stuff's election podcast</span>
                  </a>
                  <a href="https://www.stuff.co.nz/national/cannabis-referendum" rel="noopener noreferrer" target="_blank" className="stuffHeader-footercontainer--readmorecontainer---box--each">
                      <span>Cannabis referendum</span>
                  </a>
                  <a href="https://www.stuff.co.nz/national/health/euthanasia-debate" rel="noopener noreferrer" target="_blank" className="stuffHeader-footercontainer--readmorecontainer---box--each">
                      <span>Euthanasia referendum</span>
                  </a>
                  <a href="https://www.stuff.co.nz/national/politics" rel="noopener noreferrer" target="_blank" className="stuffHeader-footercontainer--readmorecontainer---box--each">
                      <span>Full campaign coverage</span>
                  </a>
              </div>
          </div>
          <div className="stuffHeader-footercontainer--creditcontainer">
              <span className="stuffHeader-footercontainer--creditcontainer---title">Credits</span>
              <div className="stuffHeader-footercontainer--creditcontainer--each">
                  <span className="stuffHeader-footercontainer--creditcontainer--each---role">Design and development</span>
                  <span className="stuffHeader-footercontainer--creditcontainer--each---name">Sungmi Kim</span>
              </div>
              <div className="stuffHeader-footercontainer--creditcontainer--each">
                  <span className="stuffHeader-footercontainer--creditcontainer--each---role">Project Director</span>
                  <span className="stuffHeader-footercontainer--creditcontainer--each---name">John Hartevelt</span>
              </div>
              <span className="stuffHeader-footercontainer--creditcontainer--each---name">Contact us by email <a className="stuffHeader-footercontainer--creditcontainer--each---link" href="mailto:newsroom@stuff.co.nz">newsroom@stuff.co.nz</a></span>
          </div>
          {<span className="stuffHeader-footercontainer--copy">&copy; {this.state.year} Stuff Limited</span>}
          </div>
          </React.Fragment>
       );
    }
}

export default Footer;